"use client";

import { Radio as RadioPrimitive } from "@base-ui/react/radio";
import { RadioGroup as RadioGroupPrimitive } from "@base-ui/react/radio-group";
import type React from "react";
import { cn } from "@/lib/utils";

export function RadioGroup({ className, ...props }: RadioGroupPrimitive.Props): React.ReactElement {
  return (
    <RadioGroupPrimitive
      className={cn("flex flex-col gap-3", className)}
      data-slot="radio-group"
      {...props}
    />
  );
}

export function Radio({ className, ...props }: RadioPrimitive.Root.Props): React.ReactElement {
  return (
    <RadioPrimitive.Root
      className={cn(
        "relative inline-flex size-4.5 shrink-0 items-center justify-center rounded-full border border-control-border bg-control-default outline-none ring-ring/15 transition-[background-color,border-color,box-shadow] hover:border-control-border-hover focus-visible:border-ring focus-visible:ring-2 aria-invalid:border-destructive aria-invalid:ring-2 aria-invalid:ring-destructive/15 data-disabled:cursor-not-allowed data-disabled:bg-muted data-disabled:opacity-60 data-checked:border-primary data-checked:bg-primary",
        className,
      )}
      data-slot="radio"
      {...props}
    >
      <RadioPrimitive.Indicator
        className="absolute -inset-px flex size-4.5 items-center justify-center rounded-full before:size-2 before:rounded-full before:bg-primary-foreground data-unchecked:hidden"
        data-slot="radio-indicator"
      />
    </RadioPrimitive.Root>
  );
}

export { Radio as RadioGroupItem, RadioGroupPrimitive, RadioPrimitive };
